import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'marketSpecPrice',
  components: {
    labSel: function labSel() {
      return import('../org/lab_sel.vue');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '市场规格价格',
        addFunName: 'marketSpecPriceAdd',
        modifyFunName: 'marketSpecPriceModify',
        delFunName: 'marketSpecPriceDel',
        queryFunName: 'marketSpecPriceQuery',
        detailFunName: 'marketSpecPriceDetail'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'report_date'
      },
      formData: {},
      rules: {
        labId: [{
          required: true,
          message: '请选择所属企业',
          trigger: 'blur'
        }],
        reportDate: [{
          required: true,
          message: '请选择统计日期',
          trigger: 'blur'
        }],
        reportOrigin: [{
          required: true,
          message: '请输入统计地区',
          trigger: 'blur'
        }],
        placeOrigin: [{
          required: true,
          message: '请输入产地|厂家',
          trigger: 'blur'
        }],
        specName: [{
          required: true,
          message: '请输入规格名称',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入价格',
          trigger: 'blur'
        }],
        productionDate: [{
          required: true,
          message: '请输入生产日期',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {},
      isBusiness: localStorage.getItem('accountCategory') === 'Business' ? true : false,
      lab_show: false
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (paramData.reportDate) {
        paramData.reportDate = dayjs(paramData.reportDate).format('YYYY-MM-DD HH:mm:ss');
      }
      if (paramData.productionDate) {
        paramData.productionDate = dayjs(paramData.productionDate).format('YYYY-MM-DD HH:mm:ss');
      }
      if (this.isBusiness) {
        this.formData.labId = localStorage.getItem('labId');
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.initFormData(this.emptyFormData);
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(_ref) {
      var _this = this;
      var id = _ref.id,
        labName = _ref.labName;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this.initFormData(_objectSpread(_objectSpread({}, res.data), {}, {
          labName: labName
        }));
        _this.editDialogTitle = _this.pageConfig.editPageName + '维护';
        _this.editDialogShow = true;
      });
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
      }
      this.lab_show = false;
    },
    del: function del(id) {
      var _this2 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this2.$api[_this2.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('删除成功');
            _this2.query();
          } else {
            _this2.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this3 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this3.tableData = res.data || [];
        _this3.totalCount = res.count;
        _this3.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this4 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this4.formData.id) {
            _this4.$api[_this4.pageConfig.modifyFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('编辑成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('编辑失败');
              }
            });
          } else {
            _this4.$api[_this4.pageConfig.addFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('新增成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'report_date';
      this.query();
    }
  }
};